<template>
<div class="row page">
        <div class="form-account form-sign-in">
            <h1>Password Reset</h1>
            <p>Please enter your email address to request to reset your password</p>
            <ValidationObserver ref="resetPasswordForm">
                <form v-on:submit.prevent="requestReset()">
                    <ul>
                        <ValidationObserver>
                            <li class="row question">
                                <label for="new-password" class="col-12 question__question">Choose a new password</label>
                                <div class="col-12">
                                    <ValidationProvider vid="newPassword" rules="required|differs:@oldPassword|min:6" v-slot="{ errors }">
                                        <input v-model="newPassword" id="new-password" type="password" class="form-account__text">
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </li>
                            <li class="row question">
                                <label for="confirm-password" class="col-12 question__question">Confirm new password</label>
                                <div class="col-12">
                                    <ValidationProvider rules="required|confirm:@newPassword|min:6" v-slot="{ errors }">
                                        <input v-model="confirmNewPassword" id="confirm-password" type="password" class="form-account__text">
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </li>
                        </ValidationObserver>
                    </ul>
                    <div v-if="infoMessage" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                    <div v-show="waiting">
                        <Spinner/>
                    </div>
                    <template v-if="!waiting && !success">
                        <button class="btn btn-primary" >Update password</button>
                        <div class="form-account__alt-action"><router-link to="/">Sign in instead</router-link></div>
                        <div class="form-account__alt-action"><router-link to="/forgot-password">Create a new password reset link</router-link></div>
                    </template>
                    <template v-if="success">
                        <router-link to="/"><button class="btn btn-primary">Go to Sign in page</button></router-link>
                    </template>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    import Spinner from '../components/Spinner'

    export default {
        name: "ResetPassword.vue",
        components: { ValidationObserver, ValidationProvider, Spinner },
        data: function () {
            return {
                token: null,
                newPassword: "",
                confirmNewPassword: "",
                waiting: false,
                success: false,
                error: false,
                infoMessage: ""
            }
        },
        computed: {
        },
        methods: {
            requestReset: function () {
                this.$refs.resetPasswordForm.validate().then(success => {
                    if (!success) {
                        return
                    }

                    this.waiting = true;
                    this.error = false;
                    this.success = false;
                    this.infoMessage = "";

                    const body = {
                        token: this.token,
                        newPassword: this.newPassword
                    }

                    this.$http.post('/guest-management/v1/users/reset-password',
                        body
                    ).then(() => {
                        this.success = true;
                        this.infoMessage = "Success - your password has been updated. Please sign in to continue";
                        return
                    }).catch(error => {
                        this.error = true;
                        if (error.response && error.response.data.message) {
                            this.infoMessage = error.response.data.message
                        } else {
                            this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    }).finally(() => {
                        this.waiting = false;
                    })
                });
            }
        },
        mounted() {
            this.token = this.$route.query.token;
            if (this.token === null || this.token === '') {
                this.error = "No reset token. Please check you email and click on the reset password link again."
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/sign-in";
</style>